"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Autocomplete = _interopRequireDefault(require("./Autocomplete"));

var _excluded = ["field", "form"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProductKindAutocomplete = function ProductKindAutocomplete(_ref) {
  var field = _ref.field,
      form = _ref.form,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    fetchOptions: getProductKindOptions,
    getOptionLabel: getProductKindOptionLabel,
    getOptionSelected: getProductKindOptionSelected,
    renderOption: renderProductKindOption,
    field: field,
    form: form
  }, props));
};

var _default = ProductKindAutocomplete; //----- ProductKind Autocomplete

exports["default"] = _default;
var kindOptions = [{
  label: "Produk Tunggal",
  value: 1
}, {
  label: "Produk Grup",
  value: 2
}];

var getProductKindOptionSelected = function getProductKindOptionSelected(option, value) {
  return option.label === value.label;
};

var getProductKindOptionLabel = function getProductKindOptionLabel(option) {
  return option ? option.label : "";
};

var getProductKindOptions = function getProductKindOptions(_ref2) {
  var setOptions = _ref2.setOptions,
      setLoading = _ref2.setLoading,
      active = _ref2.active;

  if (active) {
    setOptions(kindOptions);
    setLoading(false);
  }
};

var renderProductKindOption = function renderProductKindOption(option) {
  return option.label;
}; //----- ProductKind Autocomplete


ProductKindAutocomplete.propTypes = {
  /**
   * The label content.
   */
  label: _propTypes["default"].string,

  /**
   * Formik field
   */
  field: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].oneOf([{
      label: "Produk Tunggal",
      value: 1
    }, {
      label: "Produk Grup",
      value: 2
    }])])
  }).isRequired,

  /**
   * Formik form
   */
  form: _propTypes["default"].shape({
    touched: _propTypes["default"].object,
    errors: _propTypes["default"].object,
    setFieldValue: _propTypes["default"].func.isRequired
  }).isRequired
};